module.exports = __webpack_public_path__ + "static/media/ContactUs.cc779a77.svg";